<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" :model="search_machines">
          <el-form-item label="绑定时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              @change="dateChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机具编号">
            <el-input
              style="width:160px;"
              v-model="search_machines.FSn"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="设备sn">
            <el-input
              style="width:160px;"
              v-model="search_machines.FPinpadSn"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="厂家名称">
            <el-input
              style="width:150px;"
              v-model="search_machines.FIndustryName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="厂家型号">
            <el-input
              style="width:150px;"
              v-model="search_machines.FIndustryModel"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="机具类型">
            <el-select
              style="width:150px;"
              v-model="search_machines.FPosType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(item, index) in FPosTypeList"
                :label="item.value"
                :key="index"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input
              style="width:150px;"
              v-model="search_machines.FMerchantId"
              auto-complete="off"></el-input>
          </el-form-item>
          <!--<el-form-item label="商户名称">
                    <el-input style="width:150px;"
                              v-model="search_machines.FMerchantName"
                              auto-complete="off"></el-input>
                </el-form-item>-->
          <el-form-item label="所属代理商/业务员">
            <el-input
              style="width:150px;"
              v-model="search_machines.FOperatorOrAgent"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="machinesLoading"
              label="查询"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="machinesLoading"
        :data="machines_list"
        :header-cell-style="{background:'#FAFAFA'}"
        @sort-change="tableSortChange"
      >
        <el-table-column
          prop="fLastBandTime"
          label="绑定时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fSn"
          label="机具编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPinpadSn"
          label="设备SN"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIndustryName"
          label="厂家名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIndustryModel"
          label="厂家型号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fLeshuaModel"
          label="乐刷型号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPosType"
          label="机具类型"
          :formatter="formatPosType"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fPresentAgent"
          label="直属代理商/业务员"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="200"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              label="查看操作记录"
              @click.native="handleShowLog(scope.$index, scope.row)"></auth-button>
            <auth-button
              opt="unbind"
              type="text"
              :loading="unbindLoading"
              label="解除绑定"
              @click.native="handleUnbind(scope.row,scope.$index)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        class="pagination"
        v-if="paginations.total>0"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!-- 查看操作日志界面 -->
    <el-dialog title="" :visible.sync="dialogVisible" size="small" width="35%">
      <el-table
        border
        style="width:100%;float:left;margin-left:-5px;"
        align="center"
        v-loading="checkBasic.checkLoading"
        :data="checkBasic.machines_log_list"
        max-height="490"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fOperatorName"
          label="操作人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fOperationContent"
          label="操作内容"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="fOperatorTime"
          label="操作时间"
          align="center"
        >
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="dialogVisible = false" >关  闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import qs from 'qs'
// export default {RecordJs};
import { listLogByPinpadid, getMachineBindInfo, machineBind, listMerchantMachines, machinePosType } from '@/api/machine'
export default {
  data () {
    return {
      comeTime: '',
      machines_list: [],
      branch_list: [],
      effect_privilege_level_list: [],
      areas: [],
      citys: [],
      data: [],
      pos: [],
      scan: [],
      dataParam: {},
      domain: 'https://pos.yeahka.com/',
      picDomain: 'https://pic.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      machinesNum: '',
      staffsNum: '',
      roleName: '',
      machinesLoading: false,
      dialogVisible: false,
      addLoading: false,
      checkLoading: false,
      authLoading: false,
      picLoading: false,
      unbindLoading: false,
      zfztDisabledInput: true,
      gzztDisabledInput: true,
      groupIdDisabledInput: false,
      disabledInput: false,
      editLoading: false,
      holderDisabledInput: false,
      headShopMerchantIdInput: false,
      publicsignalAppidGZItem: true,
      publicsignalAppidItem: true,
      publicsignalAuthorizationDirectoryItem: true,
      dialogDisabled: false,
      settleDialogDisabled: false,
      settleToDisabled: false,
      nopassReason: false,
      editable: false,

      picLoadingArr: [{ idcardFront: false }, { idcardBack: false },
        { bankcardFront: false },
        { businessLicenseC: false },
        { doorPhoto: false },
        { cashierDesk: false },
        { businessInside: false },
        { nonLegSettleAuth: false },
        { nonLegIdcardFront: false },
        { nonLegIdcardBack: false },
        { protocolPage: false },
        { taxRegCert: false },
        { organizationCode: false },
        { leaseContract: false }],
      userId: '',
      userName: '',
      // 搜索表单信息
      search_machines: {
        startTime: '',
        endTime: '',
        FSn: '',
        FPinpadId: '',
        FPinpadSn: '',
        FIndustryName: '',
        FIndustryModel: '',
        FPosType: '',
        FOperatorOrAgent: '',
        FMerchantId: '',
        FMerchantName: ''
      },
      FPosTypeList: '',
      basic: {
        fAddress: '',
        fArea: '',
        fBankAccount: '',
        fBankAccountType: '',
        fUserPassword: '',
        fBankCity: '',
        fBankArea: '',
        fServicePhone: '',
        fCredentialType: 1,
        fBankBranch: '',
        fBankName: '',
        fBankcardPhone: '',
        fIdcard: '',
        fMerchantId: '',
        fMerchantName: '',
        publicsignalAppidGZ: '',
        gzhMerchantName: '',
        publicsignalAppid: '',
        publicsignalAuthorizationDirectory: '',
        shopTye: '',
        settleTo: '',
        headShopMerchantId: ''
      },
      checkBasic: {
        checkLoading: false,
        machines_log_list: []
      },
      pics: {
        idcardFront: '',
        idcardBack: '',
        bankcardFront: '',
        businessLicenseC: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        protocolPage: '',
        nonLegSettleAuth: '',
        nonLegIdcardFront: '',
        nonLegIdcardBack: '',
        taxRegCert: '',
        organizationCode: '',
        leaseContract: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面
        idcardFrontUrl: '',
        idcardBackUrl: '',
        bankcardFrontUrl: '',
        businessLicenseCUrl: '',
        doorPhotoUrl: '',
        cashierDeskUrl: '',
        businessInsideUrl: '',
        protocolPageUrl: '',
        nonLegSettleAuthUrl: '',
        taxRegCertUrl: '',
        organizationCodeUrl: '',
        leaseContractUrl: ''
      },

      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
    this.loadPosTypeList()
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_machines.FBindStartTime = value[0]
        this.search_machines.FBindEndTime = value[1]
      } else {
        this.search_machines.FBindStartTime = ''
        this.search_machines.FBindEndTime = ''
      }
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    // 显示查看操作日志界面
    handleShowLog (index, row) {
      this.dialogVisible = true
      this.checkBasic.checkLoading = true
      this.checkBasic.machines_log_list = []
      var data = {
        pinpadid: row.fPinpadId
      }
      data = qs.stringify(data)
      listLogByPinpadid(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.checkBasic.checkLoading = false
        } else {
          this.checkBasic.checkLoading = false
          this.checkBasic.machines_log_list = data.list
        }
      })
    },
    handleUnbind (row, index) {
      this.unbindLoading = true
      var data = {
        sn: row.fSn
      }
      data = qs.stringify(data)
      getMachineBindInfo(data).then((data) => {
        this.unbindLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.$confirm(
            '该机具已绑定过' + data.bindNum + '个商户，限制每个机具只可绑定' + data.maxBindNum + '个商户，目前仅可绑定' + data.allowBindNum + '个其他商户，是否确认解除绑定当前商户？',
            '', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.unbindLoading = true
            var dataUnbind = {
              sn: row.fSn,
              merchantId: '11111111', // 解绑时随便传一个商户号
              bindType: 0// 解绑时传0
            }
            dataUnbind = qs.stringify(dataUnbind)
            machineBind(dataUnbind).then((data) => {
              this.unbindLoading = false
              this.$message({
                message: data.error_msg,
                type: parseInt(data.error_code) !== 0 ? 'error' : 'success'
              })
              this.getList()
            })
          })
        }
      })
    },
    tableSortChange (val) {
      this.getList()
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.machinesNum
      // var pageSize = this.machines_list.length;
      this.search_machines.pageNo = page
      // this.search_machines.pageSize = pageSize;
      this.search_machines.Count = totalCount
      // this.search_machines.pageSize = size;
      this.getList()
    },
    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.machinesNum
      var pageNo = this.paginations.pageNum
      this.search_machines.pageSize = size
      this.search_machines.pageNo = pageNo
      this.search_machines.Count = totalCount
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        } else {
          data[s] = this.$jquery.trim(data[s])
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.checkLoading = true
      // this.search_machines.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_machines.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    getList () {
      /* var merchantName = this.search_machines.FMerchantName;
        if(null!=merchantName&&''!=merchantName&&merchantName.length<5){
          this.$message({
            showClose: true,
            message: "商户名称请最少输入5个字",
            type: 'error'
          });
          return;
        } */
      this.machinesLoading = true
      var data = this.formatSearch(this.search_machines)
      data = qs.stringify(data)
      listMerchantMachines(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.machinesLoading = false
        } else {
          this.machinesLoading = false
          this.paginations.total = data.totalCount
          this.machines_list = data.list
          this.machinesNum = data.totalCount
        }
      })
    },
    loadPosTypeList () {
      machinePosType(null).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.FPosTypeList = data.data
        }
      })
    },
    formatPosType (item) {
      var str
      switch (item.fPosType) {
        case '02': str = '传统pos'; break
        case '03': str = 'mpos'; break
        case '04': str = '智能pos'; break
        case '06': str = '扫码盒子'; break
        case '07': str = '云闪付终端'; break
        case '11':str = '刷脸设备'; break
        default: str = ''
      }
      return str
    }
  }
}

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .btm-action {
    margin-top: 20px;
    text-align: center;
  }
  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  /deep/ .el-form-item__label{
    text-align: left;
  }
</style>
